// Seasonal windows — real Singapore dates the fiction already owns (Cookie
// Clicker seasons). Opt-in server-wide bonus while active; missing one costs
// nothing.
export const SEASONS = [
  { id: 'total-defence-day', name: 'Total Defence Day', month: 2, day: 15, span: 7, mult: 3, note: 'The namesake. Ready, united, and still here.' },
  { id: 'saf-day', name: 'SAF Day', month: 7, day: 1, span: 3, mult: 2, note: 'The regulars stand to; the reservists remember.' },
  { id: 'national-day', name: 'National Day', month: 8, day: 9, span: 3, mult: 2, note: 'Majulah. Output surges with the parade.' },
];

export function activeSeason(now = new Date()) {
  const month = now.getMonth() + 1;
  const day = now.getDate();
  return SEASONS.find((season) => month === season.month && day >= season.day && day < season.day + season.span) || null;
}

export function seasonMultiplier(now = new Date()) {
  return activeSeason(now)?.mult || 1;
}
